module.exports = __webpack_public_path__ + "img/2022-05.2eda6539.jpg";